import {useEffect, useState} from 'react'

export const useGetRootSize = () => {
  const rootElement = document.getElementById('root')
  const initHeight = rootElement?.getBoundingClientRect().height
  const initWidth = rootElement?.getBoundingClientRect().width

  const [height, setHeight] = useState<number | undefined>(initHeight)
  const [width, setWidth] = useState<number | undefined>(initWidth)
  

  useEffect(() => {
    if (!window.ResizeObserver) {
      return
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height)
        setWidth(entry.contentRect.width)
      }
    });

    if (rootElement) {
      resizeObserver.observe(rootElement)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [rootElement])

  return {height, width}
}
